var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { EventEmitter } from '@angular/core';
import { InfluencerService } from '../../../services/influencer/influencer.service';
import { ActivatedRoute, Router } from '@angular/router';
import { InfluencerCampaignActivity } from '../../../../models/influencer-campaign';
import { Kpi } from '../../../../models/common';
import { CommonConstant } from '../../../app.constants';
import { AuthService } from '../../../core/auth.service';
import { AchooPopupComponent } from '../../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../../services/modal/modal.service';
import { PlaceholderVisibilityService } from '../../../services/placeholder-visibility/placeholder-visibility.service';
import { EventTrackerService, UserActionType, Page, ActivePages } from '../../../services/event-tracker/event-tracker.service';
import { CacheService } from '../../../services/cache/cache.service';
import { UserService } from '../../../services/user.service';
import { Observable } from 'rxjs/Observable';
import { EventFilter, EventFilterType, EventType } from '../../../../models/user-notification';
import { Location } from '@angular/common';
var InfluencerCampaignParam;
(function (InfluencerCampaignParam) {
    InfluencerCampaignParam[InfluencerCampaignParam["removedCampaign"] = 0] = "removedCampaign";
})(InfluencerCampaignParam || (InfluencerCampaignParam = {}));
var InfluencerCampaignActivityComponent = /** @class */ (function () {
    function InfluencerCampaignActivityComponent(influencerService, route, router, modalService, placeholderService, eventTracker, cacheService, auth, location, userService) {
        this.influencerService = influencerService;
        this.route = route;
        this.router = router;
        this.modalService = modalService;
        this.placeholderService = placeholderService;
        this.eventTracker = eventTracker;
        this.cacheService = cacheService;
        this.auth = auth;
        this.location = location;
        this.userService = userService;
        this.selectPostToDeleteFromCampaign = new EventEmitter();
        this.selectedInfluencerCampaignChanged = new EventEmitter();
        this.selectedCampaign = new InfluencerCampaignActivity();
        this.user = this.auth.getUser();
        this.slider = [
            { i: 0, value: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.value, name: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name, selected: false },
            { i: 1, value: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INVITED.value, name: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INVITED.name, selected: false },
            { i: 2, value: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.value, name: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name, selected: false },
            { i: 3, value: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.PUBLISHED.value, name: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.PUBLISHED.name, selected: false }
        ];
    }
    InfluencerCampaignActivityComponent.prototype.ngOnInit = function () {
        this.initialize();
        // segment track event
        this.eventTracker.trackUserAction(UserActionType.VIEW, Page.INFLUENCER_CAMPAIGNS, {
            id: this.influencerService.influencerDetails.id,
            name: this.influencerService.influencerDetails.name,
            type: Page.INFLUENCER
        }, undefined, undefined, {
            type: ActivePages.INFLUENCER_CAMPAIGNS,
            name: this.influencerService.influencerDetails.name,
            id: this.influencerService.influencerDetails.id
        });
    };
    InfluencerCampaignActivityComponent.prototype.initialize = function () {
        if (this.campaignInfluencerId && this.campaignInfluencerId === InfluencerCampaignParam.removedCampaign) {
            this.getCampaignListOfInfluencer();
        }
        // in case campaignInfluencerId as query param
        if (this.campaignInfluencerId && this.campaignInfluencerId !== InfluencerCampaignParam.removedCampaign
            && Number(this.campaignInfluencerId) !== this.selectedCampaignInfluencerId) {
            this.getCampaignListOfInfluencer(Number(this.campaignInfluencerId));
        }
        // in case no campaignInfluencerId as query param
        if (this.campaignInfluencerId === undefined) {
            this.getCampaignListOfInfluencer();
        }
    };
    InfluencerCampaignActivityComponent.prototype.updateRouterQueryParams = function () {
        var queryParams = Object.assign({}, this.route.snapshot.queryParams);
        queryParams['campaignInfluencerId'] = this.selectedCampaign.campaignInfluencerId;
        queryParams['selectedCampaign'] = this.selectedCampaign.campaignId;
        queryParams['activeAccount'] = this.userService.getCompanyId();
        var url = this.router.createUrlTree(['influencer', this.influencerId, 'campaign'], { queryParams: queryParams }).toString();
        this.selectedInfluencerCampaignChanged.emit(this.selectedCampaign);
        this.location.go(url);
    };
    InfluencerCampaignActivityComponent.prototype.updateInfluencerCampaignStatus = function (status) {
        var _this = this;
        var data = {
            accessLevel: this.user.type,
            id: this.selectedCampaign.campaignInfluencerId,
            status: status,
        };
        this.influencerService.updateInfluencerCampaignStatus(data).subscribe(function (res) {
            _this.selectedCampaign.status = status;
            _this.modalService.open(_this.alertUpdateInfluencerCampaignStatusSuccess, undefined, true);
        });
    };
    InfluencerCampaignActivityComponent.prototype.updateSlider = function (status) {
        this.campaignSilder = this.slider.slice(0); // clone new slider
        this.campaignSilder.forEach(function (item) {
            if (item.name === status) {
                item.selected = true;
            }
            else {
                item.selected = false;
            }
        });
    };
    InfluencerCampaignActivityComponent.prototype.clearCachedData = function (campaignInfluencerId) {
        this.cacheService.clear("campaign_influencer_list_" + campaignInfluencerId);
        this.cacheService.clear("campaign_influencer_" + campaignInfluencerId);
    };
    InfluencerCampaignActivityComponent.prototype.clearSelectionAndReset = function () {
        this.campaignInfluencerId = undefined;
        this.cacheService.clear("campaign_influencer_list_" + this.influencerId + "_" + this.userService.getCompanyId());
        this.initialize();
    };
    /**
     * get list influencer belonged to a campaign. Get data from cached memory
     * If not existed. Fetch data from server
     * @param selectedCampaignInfluencerId
     */
    InfluencerCampaignActivityComponent.prototype.getCampaignListOfInfluencer = function (selectedCampaignInfluencerId) {
        var _this = this;
        // get campaign list of influencer
        var params = {
            influencer_id: this.influencerId,
            page: CommonConstant.START_PAGE_INDEX,
            page_size: 50,
            company_id: this.userService.getCompanyId()
        };
        var cachingKey = "campaign_influencer_list_" + this.influencerId + "_" + this.userService.getCompanyId();
        this.cacheService.get(cachingKey, this.influencerService.getCampaignListOfInfluencer(params))
            .subscribe(function (res) {
            _this.campaignList = res.filter(function (item) { return item.companyId === _this.userService.getCompanyId(); });
            if (_this.campaignList.length > 0) {
                var preSelectedCampaign = _this.campaignList.find(function (item) { return item.campaignInfluencerId === selectedCampaignInfluencerId; });
                if (preSelectedCampaign) {
                    _this.selectedCampaignInfluencerId = selectedCampaignInfluencerId;
                    _this.selectedCampaign = preSelectedCampaign;
                }
                else {
                    _this.selectedCampaign = __assign({}, _this.campaignList[0]);
                    _this.selectedCampaignInfluencerId = _this.campaignList[0].id;
                }
                _this.getCampaignInfluencerData(_this.selectedCampaign.campaignInfluencerId);
            }
            else {
                _this.selectedCampaign = new InfluencerCampaignActivity();
                _this.selectedCampaignInfluencerId = undefined;
                _this.campaignInfluencerKPI = undefined;
                _this.campaignPosts = undefined;
            }
            _this.updateRouterQueryParams();
        });
    };
    InfluencerCampaignActivityComponent.prototype.getCampaignInfluencerData = function (campaignInfluencerId) {
        var _this = this;
        this.placeholderService.show(CommonConstant.INFLUENCER_CAMPAIGN_DETAILS_HOLDER);
        var campaignInfluencerSubscriptions = Observable.forkJoin([
            this.cacheService.get("campaign_influencer_" + campaignInfluencerId, this.influencerService.getCampaignInfluencerData(campaignInfluencerId)),
            this.userService.getNewEventFromLastTime(EventType.NEW_CAMPAIGN_POST, this.userService.getCompanyId(), this.userService.lastViewedCampaignTime(), new EventFilter(EventFilterType.URL_HASH, campaignInfluencerId))
        ]);
        campaignInfluencerSubscriptions.subscribe(function (_a) {
            var res = _a[0], newEvent = _a[1];
            // parse KPI
            var postKpi = new Kpi();
            postKpi.engagement.value = res.globalKpi.engagement;
            postKpi.impact.value = res.globalKpi.impact * 100;
            postKpi.impressions.value = res.globalKpi.impression;
            postKpi.reach.value = res.globalKpi.reach;
            postKpi.post.value = res.globalKpi.post;
            _this.campaignInfluencerKPI = postKpi;
            // parse post list
            var postList = res.postList.map(function (post) { return ({
                imageUrl: post.image,
                title: post.page_title,
                date: post.date,
                relativePath: post.relativePath,
                fullUrl: post.full_url,
                platformBlogs: post.platformBlogs,
                platformInstagram: post.platformInstagram,
                platformYoutube: post.platformYoutube,
                platformSnapchat: post.platformSnapchat,
                platformTwitter: post.platformTwitter,
                platformPinterest: post.platformPinterest,
                platformFacebook: post.platformFacebook,
                platformTiktok: post.platformTiktok,
                reach: post.reach.value,
                engagement: post.engagement.value,
                impressions: post.impression && post.impression.value > 0 ? post.impression.value : post.reach.value,
                impact: post.impact.value,
                urlHash: post.urlHash,
                channelId: post.channelId,
                isNew: newEvent && newEvent.events.filter(function (evt) { return evt.key === post.urlHash; }).length > 0
            }); });
            _this.campaignPosts = postList;
            // parse campaign influencer details
            _this.selectedCampaign.description = res.campaign.brief;
            _this.selectedCampaign.status = res.campaign.status;
            _this.updateSlider(_this.selectedCampaign.status);
            _this.placeholderService.hide(CommonConstant.INFLUENCER_CAMPAIGN_DETAILS_HOLDER);
        });
    };
    InfluencerCampaignActivityComponent.prototype.onSelectCampaign = function (campaign) {
        this.selectedCampaign = campaign;
        if (this.selectedCampaign === undefined) {
            this.selectedCampaign = new InfluencerCampaignActivity();
            this.selectedCampaignInfluencerId = undefined;
            this.campaignInfluencerKPI = undefined;
            this.campaignPosts = [];
            this.updateRouterQueryParams();
            return;
        }
        this.getCampaignInfluencerData(this.selectedCampaign.campaignInfluencerId);
        this.updateRouterQueryParams();
    };
    InfluencerCampaignActivityComponent.prototype.changeStatus = function (event) {
        this.closeModalDialog();
        this.previousStt = this.capitalizeStatusText(this.selectedCampaign.status);
        this.currentStt = this.capitalizeStatusText(event.name);
        this.updateInfluencerCampaignStatus(event.name);
    };
    InfluencerCampaignActivityComponent.prototype.capitalizeStatusText = function (txt) {
        return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase();
    };
    InfluencerCampaignActivityComponent.prototype.closeModalDialog = function () {
        this.modalService.close();
    };
    InfluencerCampaignActivityComponent.prototype.onSelectPost = function (evt) {
        var postToDelete = this.campaignPosts.filter(function (p) { return p.selected; }).map(function (post) { return ({
            urlHash: post.urlHash,
            channelId: post.channelId
        }); });
        this.selectPostToDeleteFromCampaign.emit({
            campaignId: this.selectedCampaign.campaignId,
            posts: postToDelete
        });
    };
    return InfluencerCampaignActivityComponent;
}());
export { InfluencerCampaignActivityComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-campaign-activity/influencer-campaign-activity.component.ts.pre-build-optimizer.js